module.exports = __webpack_public_path__ + "static/media/01.b3a85600.png";